(function () {
  'use strict';

  function injectHomepageHeaderCSS() {
    if (!document.body.classList.contains('template-index')) return;
    if (document.getElementById('c9-homepage-header-styles')) return;
    var s = document.createElement('style');
    s.id = 'c9-homepage-header-styles';
    s.textContent =
      'body.template-index .header__menu-item{font-family:\'Poppins\',\'Helvetica Neue\',sans-serif!important;font-size:1.1rem!important;font-weight:600!important;letter-spacing:.10em!important;text-transform:uppercase!important;}' +
      'body.template-index .header.page-width{height:60px!important;padding-top:0!important;padding-bottom:0!important;}' +
      'body.template-index .header__heading-logo{height:32px!important;max-height:32px!important;width:auto!important;}' +
      'body.template-index .header__icon{width:3.6rem!important;height:3.6rem!important;}' +
      'body.template-index .header__icon svg{width:1.7rem!important;height:1.7rem!important;}' +
      'body.template-index .header__menu-item,body.template-index .header__menu-item:hover{text-decoration:none!important;}' +
      'body.template-index .header__menu-item span,body.template-index .header__menu-item span:hover,body.template-index .header__active-menu-item{text-decoration:none!important;}' +
      'body.template-index .header__menu-item::after,body.template-index .header__menu-item span::after,body.template-index .header__active-menu-item::after{display:none!important;content:none!important;}' +
      'body.template-index .desktop-localization-wrapper{display:none!important;}' +
      '@media screen and (min-width:990px){' +
        'body.template-index .header--middle-left{display:flex!important;align-items:center!important;}' +
        'body.template-index .header--middle-left .header__inline-menu{flex:1!important;display:flex!important;justify-content:center!important;align-items:center!important;}' +
        'body.template-index .header--middle-left .header__inline-menu .list-menu--inline{display:flex!important;flex-direction:row!important;align-items:center!important;gap:2.8rem!important;flex-wrap:nowrap!important;}' +
      '}' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__menu-item,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__active-menu-item{color:rgba(255,255,255,0.78)!important;transition:color .18s ease,transform .22s cubic-bezier(.34,1.56,.64,1)!important;}' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__menu-item:hover{color:#fff!important;transform:scale(1.08)!important;}' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon{color:rgba(255,255,255,0.78)!important;transition:color .18s ease,transform .22s cubic-bezier(.34,1.56,.64,1)!important;}' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon:hover{color:#fff!important;transform:scale(1.14)!important;}' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon svg path,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon svg polyline,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon svg circle,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon svg line,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon svg rect{stroke:rgba(255,255,255,0.78)!important;transition:stroke .18s ease!important;}' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon:hover svg path,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon:hover svg polyline,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon:hover svg circle,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon:hover svg line,' +
      'body.template-index .header-wrapper:not(.c9-scrolled) .header__icon:hover svg rect{stroke:#fff!important;}' +
      'body.template-index .header-wrapper.c9-scrolled .header__menu-item,' +
      'body.template-index .header-wrapper.c9-scrolled .header__active-menu-item{color:rgba(12,12,12,.55)!important;transition:color .18s ease!important;}' +
      'body.template-index .header-wrapper.c9-scrolled .header__menu-item:hover{color:#0c0c0c!important;transform:none!important;}' +
      'body.template-index .header-wrapper.c9-scrolled .header__icon{color:rgba(12,12,12,.55)!important;transition:color .18s ease!important;}' +
      'body.template-index .header-wrapper.c9-scrolled .header__icon:hover{color:#0c0c0c!important;transform:none!important;}' +
      'body.template-index .header-wrapper.c9-scrolled .header__heading-logo{filter:none!important;}';
    document.head.appendChild(s);
  }

  function setActiveNav() {
    var path = window.location.pathname;
    document.querySelectorAll('.header__inline-menu a.header__menu-item').forEach(function (el) {
      if (el.pathname === path) {
        el.classList.add('c9-nav-active');
      }
    });
  }

  function setStickyActiveNav() {
    var path = window.location.pathname;
    document.querySelectorAll('#c9-sticky .c9-sticky__link').forEach(function (el) {
      el.classList.remove('is-active');
      if (el.pathname === path) {
        el.classList.add('is-active');
      }
    });
  }

  function initStickyNonHome() {
    if (document.body.classList.contains('template-index')) return;
    var sticky = document.getElementById('c9-sticky');
    if (!sticky) return;
    var THRESHOLD = 80;
    function update() {
      if (window.scrollY > THRESHOLD) {
        sticky.classList.add('c9-sticky--visible');
      } else {
        sticky.classList.remove('c9-sticky--visible');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initHeaderEnhancements() {
    if (!document.getElementById('c9-header-enhancements-styles')) {
      var s = document.createElement('style');
      s.id = 'c9-header-enhancements-styles';
      s.textContent =
        '.shopify-section-group-header-group{z-index:9999!important;}' +
        'body.template-index .shopify-section-group-header-group{z-index:9999!important;}' +
        '.menu-drawer__close-button svg,.menu-drawer__close-button .icon{width:1.7rem!important;height:1.7rem!important;}' +
        '.header__icon--menu .icon-close,' +
        '.header__icon--menu svg.icon-close,' +
        '.menu-opening .header__icon--menu .icon-close,' +
        '.menu-opening .header__icon--menu svg.icon-close{width:1.7rem!important;height:1.7rem!important;}' +
        '.menu-drawer a[href*="tiktok.com"]{display:none!important;}' +
        '.menu-drawer li:has(> a[href*="tiktok.com"]),' +
        '.menu-drawer__utility-links li:has(> a[href*="tiktok.com"]){display:none!important;}' +
        '#c9-sticky .c9-sticky__menu{display:none;background:none;border:none;padding:0;cursor:pointer;color:rgba(12,12,12,.55);align-items:center;justify-content:center;transition:color .18s ease;}' +
        '#c9-sticky .c9-sticky__menu:hover{color:#0c0c0c;}' +
        '#c9-sticky .c9-sticky__menu svg{display:block;}' +
        /* Country selector\'s inline search icon (magnifying glass next to the
           country filter input). Default size is far too large; tone it down
           and use a muted grey to match the rest of the menu drawer. Scoped
           by .country-filter__search-icon — only matches the single element
           inside the country localization snippet. */
        '.country-filter__search-icon svg{width:1.7rem!important;height:1.7rem!important;color:rgba(12,12,12,0.4)!important;}' +
        '.country-filter__search-icon{color:rgba(12,12,12,0.4)!important;}' +
        '.country-filter__search-icon svg path,' +
        '.country-filter__search-icon svg circle,' +
        '.country-filter__search-icon svg line{stroke:rgba(12,12,12,0.4)!important;}' +
        'body.template-index .header-wrapper:has(menu-drawer details[open]),' +
        'body.template-index .header-wrapper:has(header-drawer details[open]),' +
        'body.template-index .header-wrapper:has(details.menu-opening),' +
        'body.template-index.menu-opening .header-wrapper,' +
        'body.template-index .menu-opening .header-wrapper,' +
        'body.template-index .header-wrapper.menu-opening{opacity:1!important;pointer-events:auto!important;}' +
        'body.template-index .header-wrapper[data-c9-menu-active]{background:#fff!important;}' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon{color:rgba(12,12,12,.55)!important;}' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon svg path,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon svg polyline,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon svg circle,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon svg line,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon svg rect{stroke:rgba(12,12,12,.55)!important;}' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon:hover{color:#0c0c0c!important;}' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon:hover svg path,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon:hover svg polyline,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon:hover svg circle,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon:hover svg line,' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__icon:hover svg rect{stroke:#0c0c0c!important;}' +
        'body.template-index .header-wrapper[data-c9-menu-active] .header__heading-logo{filter:none!important;}' +
        '@media (max-width:749px){' +
          '#c9-sticky .c9-sticky__inner{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;}' +
          '#c9-sticky .c9-sticky__menu{display:inline-flex;justify-self:start;}' +
          '#c9-sticky .c9-sticky__logo{justify-self:center;}' +
          '#c9-sticky .c9-sticky__actions{justify-self:end;}' +
          '#c9-sticky .c9-sticky__icon[aria-label="Account"]{display:none;}' +
          '.header__icon--menu svg{width:1.7rem!important;height:1.7rem!important;}' +
          'body.template-index .header-wrapper .header__icon--menu svg{width:1.7rem!important;height:1.7rem!important;}' +
          'body.template-index .menu-drawer{height:calc(100vh - 60px)!important;height:calc(100dvh - 60px)!important;}' +
          'body.template-index .menu-drawer__utility-links{display:block!important;visibility:visible!important;opacity:1!important;}' +
          'body.template-index .header-wrapper .menu-drawer-container .disclosure__button,' +
          'body.template-index .header-wrapper .menu-drawer-container .disclosure__button span,' +
          'body.template-index .header-wrapper .menu-drawer .disclosure__button,' +
          'body.template-index .header-wrapper .menu-drawer .disclosure__button span,' +
          'body.template-index .header-wrapper .menu-drawer-container localization-form,' +
          'body.template-index .header-wrapper .menu-drawer-container localization-form *{color:rgba(12,12,12,0.85)!important;}' +
          'body.template-index .header-wrapper .menu-drawer-container .disclosure__button svg path,' +
          'body.template-index .header-wrapper .menu-drawer-container .disclosure__button svg polyline,' +
          'body.template-index .header-wrapper .menu-drawer .disclosure__button svg path,' +
          'body.template-index .header-wrapper .menu-drawer .disclosure__button svg polyline{stroke:rgba(12,12,12,0.85)!important;}' +
          'body.template-index .menu-drawer__utility-links,' +
          'body.template-index .menu-drawer__utility-links a,' +
          'body.template-index .menu-drawer__utility-links span,' +
          'body.template-index .menu-drawer__account,' +
          'body.template-index .menu-drawer__account a,' +
          'body.template-index .menu-drawer__account span,' +
          'body.template-index .menu-drawer .list-social,' +
          'body.template-index .menu-drawer .list-social a,' +
          'body.template-index .menu-drawer .list-social__link{color:rgba(12,12,12,0.85)!important;}' +
          'body.template-index .menu-drawer .list-social svg{fill:currentColor!important;}' +
        '}';
      document.head.appendChild(s);
    }

    function removeTikTokFromMenu() {
      document.querySelectorAll('.menu-drawer a[href*="tiktok.com"]').forEach(function (a) {
        var li = a.closest('li');
        if (li) li.style.display = 'none';
        else a.style.display = 'none';
      });
    }
    removeTikTokFromMenu();
    setTimeout(removeTikTokFromMenu, 500);

    var sticky = document.getElementById('c9-sticky');
    if (sticky && !sticky.querySelector('.c9-sticky__menu')) {
      var inner = sticky.querySelector('.c9-sticky__inner');
      if (inner) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'c9-sticky__menu';
        btn.setAttribute('aria-label', 'Menu');
        btn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var staticMenu = document.querySelector('.header__icon--menu');
          if (!staticMenu) return;
          var isHomepage = document.body.classList.contains('template-index');

          if (!isHomepage) {
            if (window.scrollY > 0) window.scrollTo(0, 0);
            staticMenu.click();
            return;
          }

          var scrollY = window.scrollY;
          var bodyStyle = document.body.style;
          var savedPosition = bodyStyle.position;
          var savedTop = bodyStyle.top;
          var savedLeft = bodyStyle.left;
          var savedRight = bodyStyle.right;
          var savedWidth = bodyStyle.width;

          bodyStyle.position = 'fixed';
          bodyStyle.top = '-' + scrollY + 'px';
          bodyStyle.left = '0';
          bodyStyle.right = '0';
          bodyStyle.width = '100%';

          var headerWrapper = document.querySelector('.header-wrapper');
          if (headerWrapper) headerWrapper.setAttribute('data-c9-menu-active', '1');

          staticMenu.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));

          var bodyObserver = new MutationObserver(function () {
            if (!/overflow-hidden/.test(document.body.className)) {
              bodyObserver.disconnect();
              bodyStyle.position = savedPosition;
              bodyStyle.top = savedTop;
              bodyStyle.left = savedLeft;
              bodyStyle.right = savedRight;
              bodyStyle.width = savedWidth;
              window.scrollTo(0, scrollY);
            }
          });
          bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

          var drawer = staticMenu.closest('header-drawer, menu-drawer');
          var details = drawer ? drawer.querySelector('details') : staticMenu.closest('details');
          if (details) {
            var detailsObserver = new MutationObserver(function () {
              if (!details.hasAttribute('open')) {
                detailsObserver.disconnect();
                if (headerWrapper) headerWrapper.removeAttribute('data-c9-menu-active');
              }
            });
            detailsObserver.observe(details, { attributes: true, attributeFilter: ['open'] });
          }
        });
        inner.insertBefore(btn, inner.firstChild);
      }
    }

    var hamSvg = document.querySelector('.header__icon--menu .icon-hamburger');
    if (hamSvg && !hamSvg.hasAttribute('data-c9-replaced')) {
      hamSvg.setAttribute('viewBox', '0 0 24 24');
      hamSvg.setAttribute('fill', 'none');
      hamSvg.setAttribute('stroke', 'currentColor');
      hamSvg.setAttribute('stroke-width', '1.5');
      hamSvg.setAttribute('stroke-linecap', 'round');
      hamSvg.setAttribute('stroke-linejoin', 'round');
      hamSvg.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
      hamSvg.setAttribute('data-c9-replaced', '1');
    }

    if (document.body.classList.contains('template-index')) {
      var closeSvg = document.querySelector('.header__icon--menu .icon-close');
      if (closeSvg && !closeSvg.hasAttribute('data-c9-replaced-close')) {
        closeSvg.setAttribute('viewBox', '0 0 24 24');
        closeSvg.setAttribute('fill', 'none');
        closeSvg.setAttribute('stroke', 'currentColor');
        closeSvg.setAttribute('stroke-width', '1.5');
        closeSvg.setAttribute('stroke-linecap', 'round');
        closeSvg.setAttribute('stroke-linejoin', 'round');
        closeSvg.innerHTML = '<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>';
        closeSvg.setAttribute('data-c9-replaced-close', '1');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectHomepageHeaderCSS();
      setActiveNav();
      setStickyActiveNav();
      initStickyNonHome();
      initHeaderEnhancements();
    });
  } else {
    injectHomepageHeaderCSS();
    setActiveNav();
    setStickyActiveNav();
    initStickyNonHome();
    initHeaderEnhancements();
  }

})();
